unit View.Banco_Carteiras.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewBanco_CarteirasEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbconta_id: TLabel;
    edconta_id: TDBEdit;
    lbtipo_id: TLabel;
    edtipo_id: TDBEdit;
    lbstatus: TLabel;
    edstatus: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbcodigo: TLabel;
    edcodigo: TDBEdit;
    lbcontrato: TLabel;
    edcontrato: TDBEdit;
    lbconvenio: TLabel;
    edconvenio: TDBEdit;
    lbvariacao: TLabel;
    edvariacao: TDBEdit;
    lbmensagem1: TLabel;
    edmensagem1: TDBEdit;
    lbmensagem2: TLabel;
    edmensagem2: TDBEdit;
    lbmensagem3: TLabel;
    edmensagem3: TDBEdit;
    lbtaxa_juros: TLabel;
    edtaxa_juros: TDBEdit;
    lbtaxa_multa: TLabel;
    edtaxa_multa: TDBEdit;
    lbcarteira_cliente_emite_boleto: TLabel;
    edcarteira_cliente_emite_boleto: TDBEdit;
    lbcarteira_permite_liquidacao_antecipada: TLabel;
    edcarteira_permite_liquidacao_antecipada: TDBEdit;
    lbdesconto_acrescimo_antecipacao: TLabel;
    eddesconto_acrescimo_antecipacao: TDBEdit;
    lbtaxa_desconto_acrescimo_antecipado: TLabel;
    edtaxa_desconto_acrescimo_antecipado: TDBEdit;
    lbdias_limite_desconto_acrescimo_antecipacao: TLabel;
    eddias_limite_desconto_acrescimo_antecipacao: TDBEdit;
    lbmensagem_desconto: TLabel;
    edmensagem_desconto: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientBanco_CarteirasGet: TXDataWebClient;
    XDataClientBanco_CarteirasDelete: TXDataWebClient;
    Banco_CarteirasDataset: TXDataWebDataSet;
    Banco_CarteirasDatasetid: TIntegerField;
    Banco_CarteirasDatasetaliado_id: TIntegerField;
    Banco_CarteirasDatasetdata_base_id: TIntegerField;
    Banco_CarteirasDatasetconta_id: TIntegerField;
    Banco_CarteirasDatasettipo_id: TIntegerField;
    Banco_CarteirasDatasetstatus: TIntegerField;
    Banco_CarteirasDatasetnome: TStringField;
    Banco_CarteirasDatasetcodigo: TStringField;
    Banco_CarteirasDatasetcontrato: TStringField;
    Banco_CarteirasDatasetconvenio: TStringField;
    Banco_CarteirasDatasetvariacao: TStringField;
    Banco_CarteirasDatasetmensagem1: TStringField;
    Banco_CarteirasDatasetmensagem2: TStringField;
    Banco_CarteirasDatasetmensagem3: TStringField;
    Banco_CarteirasDatasettaxa_juros: TFloatField;
    Banco_CarteirasDatasettaxa_multa: TFloatField;
    Banco_CarteirasDatasetcarteira_cliente_emite_boleto: TBooleanField;
    Banco_CarteirasDatasetcarteira_permite_liquidacao_antecipada: TBooleanField;
    Banco_CarteirasDatasetdesconto_acrescimo_antecipacao: TIntegerField;
    Banco_CarteirasDatasettaxa_desconto_acrescimo_antecipado: TFloatField;
    Banco_CarteirasDatasetdias_limite_desconto_acrescimo_antecipacao: TIntegerField;
    Banco_CarteirasDatasetmensagem_desconto: TStringField;
    Banco_CarteirasDatasetcodigo_interno: TIntegerField;
    Banco_CarteirasDatasetexcluido: TBooleanField;
    Banco_CarteirasDatasetinclusao: TDateTimeField;
    Banco_CarteirasDatasetalteracao: TDateTimeField;
    Banco_CarteirasDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientBanco_CarteirasGetLoad(Response: TXDataClientResponse);
    procedure XDataClientBanco_CarteirasDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientBanco_CarteirasDeleteError(Error: TXDataClientError);
    procedure Banco_CarteirasDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewBanco_CarteirasEdit: TFViewBanco_CarteirasEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewBanco_CarteirasEdit }

procedure TFViewBanco_CarteirasEdit.btSaveClick(Sender: TObject);
begin
  if Banco_CarteirasDataset.State in dsEditModes then
  begin
        Banco_CarteirasDataset.Post;
    Banco_CarteirasDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewBanco_CarteirasEdit.btDeleteClick(Sender: TObject);
begin
  if Banco_CarteirasDataset.State in dsEditModes then
    Banco_CarteirasDataset.Post;
  XDataClientBanco_CarteirasDelete.Delete(Banco_CarteirasDataset.EntitySetName,
    TJSObject(Banco_CarteirasDataset.CurrentData));
end;


class function TFViewBanco_CarteirasEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewBanco_CarteirasEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewBanco_CarteirasEdit.InsertEntity;
begin
  Banco_CarteirasDataset.Close;
  Banco_CarteirasDataset.SetJsonData('{}');
  Banco_CarteirasDataset.Open;
  Banco_CarteirasDataset.Insert;
end;

class function TFViewBanco_CarteirasEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewBanco_CarteirasEdit(AForm).FInserting := AInserting;
    TFViewBanco_CarteirasEdit(AForm).FId := AId;
    TFViewBanco_CarteirasEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewBanco_CarteirasEdit(AForm).InsertEntity
    else
      TFViewBanco_CarteirasEdit(AForm).LoadEntity;
    TFViewBanco_CarteirasEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewBanco_CarteirasEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewBanco_CarteirasEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Banco_CarteirasDataset.Connection.Model.DefaultSchema.FindEntityType(
      Banco_CarteirasDataset.EntitySetName
    )
  );
  XDataClientBanco_CarteirasGet.Get(Banco_CarteirasDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewBanco_CarteirasEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewBanco_CarteirasEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewBanco_CarteirasEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewBanco_CarteirasEdit.XDataClientBanco_CarteirasGetLoad(Response: TXDataClientResponse);
begin
  Banco_CarteirasDataset.Close;
  Banco_CarteirasDataset.SetJsonData(Response.Result);
  Banco_CarteirasDataset.Open;
  
  Banco_CarteirasDataset.Edit;  
end;

procedure TFViewBanco_CarteirasEdit.XDataClientBanco_CarteirasDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewBanco_CarteirasEdit.XDataClientBanco_CarteirasDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewBanco_CarteirasEdit.Banco_CarteirasDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewBanco_CarteirasEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewBanco_CarteirasEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.banco_carteiras.form.message');
  lbMessage := TLabel.Create('view.banco_carteiras.form.message.label');
  btCloseMessage := TButton.Create('view.banco_carteiras.form.message.button');
  btCancel := TButton.Create('view.banco_carteiras.form.btBack');
  btSave := TButton.Create('view.banco_carteiras.form.btSave');
  btDelete := TButton.Create('view.banco_carteiras.form.btDelete');
  lbid := TLabel.Create('view.banco_carteiras.form.lbid');
  edid := TDBEdit.Create('view.banco_carteiras.form.edid');
  lbaliado_id := TLabel.Create('view.banco_carteiras.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.banco_carteiras.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.banco_carteiras.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.banco_carteiras.form.eddata_base_id');
  lbconta_id := TLabel.Create('view.banco_carteiras.form.lbconta_id');
  edconta_id := TDBEdit.Create('view.banco_carteiras.form.edconta_id');
  lbtipo_id := TLabel.Create('view.banco_carteiras.form.lbtipo_id');
  edtipo_id := TDBEdit.Create('view.banco_carteiras.form.edtipo_id');
  lbstatus := TLabel.Create('view.banco_carteiras.form.lbstatus');
  edstatus := TDBEdit.Create('view.banco_carteiras.form.edstatus');
  lbnome := TLabel.Create('view.banco_carteiras.form.lbnome');
  ednome := TDBEdit.Create('view.banco_carteiras.form.ednome');
  lbcodigo := TLabel.Create('view.banco_carteiras.form.lbcodigo');
  edcodigo := TDBEdit.Create('view.banco_carteiras.form.edcodigo');
  lbcontrato := TLabel.Create('view.banco_carteiras.form.lbcontrato');
  edcontrato := TDBEdit.Create('view.banco_carteiras.form.edcontrato');
  lbconvenio := TLabel.Create('view.banco_carteiras.form.lbconvenio');
  edconvenio := TDBEdit.Create('view.banco_carteiras.form.edconvenio');
  lbvariacao := TLabel.Create('view.banco_carteiras.form.lbvariacao');
  edvariacao := TDBEdit.Create('view.banco_carteiras.form.edvariacao');
  lbmensagem1 := TLabel.Create('view.banco_carteiras.form.lbmensagem1');
  edmensagem1 := TDBEdit.Create('view.banco_carteiras.form.edmensagem1');
  lbmensagem2 := TLabel.Create('view.banco_carteiras.form.lbmensagem2');
  edmensagem2 := TDBEdit.Create('view.banco_carteiras.form.edmensagem2');
  lbmensagem3 := TLabel.Create('view.banco_carteiras.form.lbmensagem3');
  edmensagem3 := TDBEdit.Create('view.banco_carteiras.form.edmensagem3');
  lbtaxa_juros := TLabel.Create('view.banco_carteiras.form.lbtaxa_juros');
  edtaxa_juros := TDBEdit.Create('view.banco_carteiras.form.edtaxa_juros');
  lbtaxa_multa := TLabel.Create('view.banco_carteiras.form.lbtaxa_multa');
  edtaxa_multa := TDBEdit.Create('view.banco_carteiras.form.edtaxa_multa');
  lbcarteira_cliente_emite_boleto := TLabel.Create('view.banco_carteiras.form.lbcarteira_cliente_emite_boleto');
  edcarteira_cliente_emite_boleto := TDBEdit.Create('view.banco_carteiras.form.edcarteira_cliente_emite_boleto');
  lbcarteira_permite_liquidacao_antecipada := TLabel.Create('view.banco_carteiras.form.lbcarteira_permite_liquidacao_antecipada');
  edcarteira_permite_liquidacao_antecipada := TDBEdit.Create('view.banco_carteiras.form.edcarteira_permite_liquidacao_antecipada');
  lbdesconto_acrescimo_antecipacao := TLabel.Create('view.banco_carteiras.form.lbdesconto_acrescimo_antecipacao');
  eddesconto_acrescimo_antecipacao := TDBEdit.Create('view.banco_carteiras.form.eddesconto_acrescimo_antecipacao');
  lbtaxa_desconto_acrescimo_antecipado := TLabel.Create('view.banco_carteiras.form.lbtaxa_desconto_acrescimo_antecipado');
  edtaxa_desconto_acrescimo_antecipado := TDBEdit.Create('view.banco_carteiras.form.edtaxa_desconto_acrescimo_antecipado');
  lbdias_limite_desconto_acrescimo_antecipacao := TLabel.Create('view.banco_carteiras.form.lbdias_limite_desconto_acrescimo_antecipacao');
  eddias_limite_desconto_acrescimo_antecipacao := TDBEdit.Create('view.banco_carteiras.form.eddias_limite_desconto_acrescimo_antecipacao');
  lbmensagem_desconto := TLabel.Create('view.banco_carteiras.form.lbmensagem_desconto');
  edmensagem_desconto := TDBEdit.Create('view.banco_carteiras.form.edmensagem_desconto');
  lbcodigo_interno := TLabel.Create('view.banco_carteiras.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.banco_carteiras.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.banco_carteiras.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.banco_carteiras.form.edexcluido');
  lbinclusao := TLabel.Create('view.banco_carteiras.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.banco_carteiras.form.edinclusao');
  lbalteracao := TLabel.Create('view.banco_carteiras.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.banco_carteiras.form.edalteracao');
  lbexclusao := TLabel.Create('view.banco_carteiras.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.banco_carteiras.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Banco_CarteirasDataset := TXDataWebDataSet.Create(Self);
  Banco_CarteirasDatasetid := TIntegerField.Create(Self);
  Banco_CarteirasDatasetaliado_id := TIntegerField.Create(Self);
  Banco_CarteirasDatasetdata_base_id := TIntegerField.Create(Self);
  Banco_CarteirasDatasetconta_id := TIntegerField.Create(Self);
  Banco_CarteirasDatasettipo_id := TIntegerField.Create(Self);
  Banco_CarteirasDatasetstatus := TIntegerField.Create(Self);
  Banco_CarteirasDatasetnome := TStringField.Create(Self);
  Banco_CarteirasDatasetcodigo := TStringField.Create(Self);
  Banco_CarteirasDatasetcontrato := TStringField.Create(Self);
  Banco_CarteirasDatasetconvenio := TStringField.Create(Self);
  Banco_CarteirasDatasetvariacao := TStringField.Create(Self);
  Banco_CarteirasDatasetmensagem1 := TStringField.Create(Self);
  Banco_CarteirasDatasetmensagem2 := TStringField.Create(Self);
  Banco_CarteirasDatasetmensagem3 := TStringField.Create(Self);
  Banco_CarteirasDatasettaxa_juros := TFloatField.Create(Self);
  Banco_CarteirasDatasettaxa_multa := TFloatField.Create(Self);
  Banco_CarteirasDatasetcarteira_cliente_emite_boleto := TBooleanField.Create(Self);
  Banco_CarteirasDatasetcarteira_permite_liquidacao_antecipada := TBooleanField.Create(Self);
  Banco_CarteirasDatasetdesconto_acrescimo_antecipacao := TIntegerField.Create(Self);
  Banco_CarteirasDatasettaxa_desconto_acrescimo_antecipado := TFloatField.Create(Self);
  Banco_CarteirasDatasetdias_limite_desconto_acrescimo_antecipacao := TIntegerField.Create(Self);
  Banco_CarteirasDatasetmensagem_desconto := TStringField.Create(Self);
  Banco_CarteirasDatasetcodigo_interno := TIntegerField.Create(Self);
  Banco_CarteirasDatasetexcluido := TBooleanField.Create(Self);
  Banco_CarteirasDatasetinclusao := TDateTimeField.Create(Self);
  Banco_CarteirasDatasetalteracao := TDateTimeField.Create(Self);
  Banco_CarteirasDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientBanco_CarteirasGet := TXDataWebClient.Create(Self);
  XDataClientBanco_CarteirasDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbconta_id.BeforeLoadDFMValues;
  edconta_id.BeforeLoadDFMValues;
  lbtipo_id.BeforeLoadDFMValues;
  edtipo_id.BeforeLoadDFMValues;
  lbstatus.BeforeLoadDFMValues;
  edstatus.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbcodigo.BeforeLoadDFMValues;
  edcodigo.BeforeLoadDFMValues;
  lbcontrato.BeforeLoadDFMValues;
  edcontrato.BeforeLoadDFMValues;
  lbconvenio.BeforeLoadDFMValues;
  edconvenio.BeforeLoadDFMValues;
  lbvariacao.BeforeLoadDFMValues;
  edvariacao.BeforeLoadDFMValues;
  lbmensagem1.BeforeLoadDFMValues;
  edmensagem1.BeforeLoadDFMValues;
  lbmensagem2.BeforeLoadDFMValues;
  edmensagem2.BeforeLoadDFMValues;
  lbmensagem3.BeforeLoadDFMValues;
  edmensagem3.BeforeLoadDFMValues;
  lbtaxa_juros.BeforeLoadDFMValues;
  edtaxa_juros.BeforeLoadDFMValues;
  lbtaxa_multa.BeforeLoadDFMValues;
  edtaxa_multa.BeforeLoadDFMValues;
  lbcarteira_cliente_emite_boleto.BeforeLoadDFMValues;
  edcarteira_cliente_emite_boleto.BeforeLoadDFMValues;
  lbcarteira_permite_liquidacao_antecipada.BeforeLoadDFMValues;
  edcarteira_permite_liquidacao_antecipada.BeforeLoadDFMValues;
  lbdesconto_acrescimo_antecipacao.BeforeLoadDFMValues;
  eddesconto_acrescimo_antecipacao.BeforeLoadDFMValues;
  lbtaxa_desconto_acrescimo_antecipado.BeforeLoadDFMValues;
  edtaxa_desconto_acrescimo_antecipado.BeforeLoadDFMValues;
  lbdias_limite_desconto_acrescimo_antecipacao.BeforeLoadDFMValues;
  eddias_limite_desconto_acrescimo_antecipacao.BeforeLoadDFMValues;
  lbmensagem_desconto.BeforeLoadDFMValues;
  edmensagem_desconto.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Banco_CarteirasDataset.BeforeLoadDFMValues;
  Banco_CarteirasDatasetid.BeforeLoadDFMValues;
  Banco_CarteirasDatasetaliado_id.BeforeLoadDFMValues;
  Banco_CarteirasDatasetdata_base_id.BeforeLoadDFMValues;
  Banco_CarteirasDatasetconta_id.BeforeLoadDFMValues;
  Banco_CarteirasDatasettipo_id.BeforeLoadDFMValues;
  Banco_CarteirasDatasetstatus.BeforeLoadDFMValues;
  Banco_CarteirasDatasetnome.BeforeLoadDFMValues;
  Banco_CarteirasDatasetcodigo.BeforeLoadDFMValues;
  Banco_CarteirasDatasetcontrato.BeforeLoadDFMValues;
  Banco_CarteirasDatasetconvenio.BeforeLoadDFMValues;
  Banco_CarteirasDatasetvariacao.BeforeLoadDFMValues;
  Banco_CarteirasDatasetmensagem1.BeforeLoadDFMValues;
  Banco_CarteirasDatasetmensagem2.BeforeLoadDFMValues;
  Banco_CarteirasDatasetmensagem3.BeforeLoadDFMValues;
  Banco_CarteirasDatasettaxa_juros.BeforeLoadDFMValues;
  Banco_CarteirasDatasettaxa_multa.BeforeLoadDFMValues;
  Banco_CarteirasDatasetcarteira_cliente_emite_boleto.BeforeLoadDFMValues;
  Banco_CarteirasDatasetcarteira_permite_liquidacao_antecipada.BeforeLoadDFMValues;
  Banco_CarteirasDatasetdesconto_acrescimo_antecipacao.BeforeLoadDFMValues;
  Banco_CarteirasDatasettaxa_desconto_acrescimo_antecipado.BeforeLoadDFMValues;
  Banco_CarteirasDatasetdias_limite_desconto_acrescimo_antecipacao.BeforeLoadDFMValues;
  Banco_CarteirasDatasetmensagem_desconto.BeforeLoadDFMValues;
  Banco_CarteirasDatasetcodigo_interno.BeforeLoadDFMValues;
  Banco_CarteirasDatasetexcluido.BeforeLoadDFMValues;
  Banco_CarteirasDatasetinclusao.BeforeLoadDFMValues;
  Banco_CarteirasDatasetalteracao.BeforeLoadDFMValues;
  Banco_CarteirasDatasetexclusao.BeforeLoadDFMValues;
  XDataClientBanco_CarteirasGet.BeforeLoadDFMValues;
  XDataClientBanco_CarteirasDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewBanco_CarteirasEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 994;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 934;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 934;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 934;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbconta_id.SetParentComponent(Self);
    lbconta_id.Name := 'lbconta_id';
    lbconta_id.Left := 24;
    lbconta_id.Top := 273;
    lbconta_id.Width := 14;
    lbconta_id.Height := 13;
    lbconta_id.Caption := 'conta_id:';
    lbconta_id.Transparent := True;
    edconta_id.SetParentComponent(Self);
    edconta_id.Name := 'edconta_id';
    edconta_id.Left := 221;
    edconta_id.Top := 270;
    edconta_id.Width := 200;
    edconta_id.Height := 21;
    edconta_id.Enabled := True;
    edconta_id.TabOrder := 9;
    edconta_id.Text := 'edconta_id';
    edconta_id.DataField := 'conta_id';
    edconta_id.DataSource := DataSource;
    lbtipo_id.SetParentComponent(Self);
    lbtipo_id.Name := 'lbtipo_id';
    lbtipo_id.Left := 24;
    lbtipo_id.Top := 300;
    lbtipo_id.Width := 14;
    lbtipo_id.Height := 13;
    lbtipo_id.Caption := 'tipo_id:';
    lbtipo_id.Transparent := True;
    edtipo_id.SetParentComponent(Self);
    edtipo_id.Name := 'edtipo_id';
    edtipo_id.Left := 221;
    edtipo_id.Top := 297;
    edtipo_id.Width := 200;
    edtipo_id.Height := 21;
    edtipo_id.Enabled := True;
    edtipo_id.TabOrder := 10;
    edtipo_id.Text := 'edtipo_id';
    edtipo_id.DataField := 'tipo_id';
    edtipo_id.DataSource := DataSource;
    lbstatus.SetParentComponent(Self);
    lbstatus.Name := 'lbstatus';
    lbstatus.Left := 24;
    lbstatus.Top := 327;
    lbstatus.Width := 14;
    lbstatus.Height := 13;
    lbstatus.Caption := 'status:';
    lbstatus.Transparent := True;
    edstatus.SetParentComponent(Self);
    edstatus.Name := 'edstatus';
    edstatus.Left := 221;
    edstatus.Top := 324;
    edstatus.Width := 200;
    edstatus.Height := 21;
    edstatus.Enabled := True;
    edstatus.TabOrder := 11;
    edstatus.Text := 'edstatus';
    edstatus.DataField := 'status';
    edstatus.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 354;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 351;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 12;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbcodigo.SetParentComponent(Self);
    lbcodigo.Name := 'lbcodigo';
    lbcodigo.Left := 24;
    lbcodigo.Top := 381;
    lbcodigo.Width := 14;
    lbcodigo.Height := 13;
    lbcodigo.Caption := 'codigo:';
    lbcodigo.Transparent := True;
    edcodigo.SetParentComponent(Self);
    edcodigo.Name := 'edcodigo';
    edcodigo.Left := 221;
    edcodigo.Top := 378;
    edcodigo.Width := 200;
    edcodigo.Height := 21;
    edcodigo.Enabled := True;
    edcodigo.TabOrder := 13;
    edcodigo.Text := 'edcodigo';
    edcodigo.DataField := 'codigo';
    edcodigo.DataSource := DataSource;
    lbcontrato.SetParentComponent(Self);
    lbcontrato.Name := 'lbcontrato';
    lbcontrato.Left := 24;
    lbcontrato.Top := 408;
    lbcontrato.Width := 14;
    lbcontrato.Height := 13;
    lbcontrato.Caption := 'contrato:';
    lbcontrato.Transparent := True;
    edcontrato.SetParentComponent(Self);
    edcontrato.Name := 'edcontrato';
    edcontrato.Left := 221;
    edcontrato.Top := 405;
    edcontrato.Width := 200;
    edcontrato.Height := 21;
    edcontrato.Enabled := True;
    edcontrato.TabOrder := 14;
    edcontrato.Text := 'edcontrato';
    edcontrato.DataField := 'contrato';
    edcontrato.DataSource := DataSource;
    lbconvenio.SetParentComponent(Self);
    lbconvenio.Name := 'lbconvenio';
    lbconvenio.Left := 24;
    lbconvenio.Top := 435;
    lbconvenio.Width := 14;
    lbconvenio.Height := 13;
    lbconvenio.Caption := 'convenio:';
    lbconvenio.Transparent := True;
    edconvenio.SetParentComponent(Self);
    edconvenio.Name := 'edconvenio';
    edconvenio.Left := 221;
    edconvenio.Top := 432;
    edconvenio.Width := 200;
    edconvenio.Height := 21;
    edconvenio.Enabled := True;
    edconvenio.TabOrder := 15;
    edconvenio.Text := 'edconvenio';
    edconvenio.DataField := 'convenio';
    edconvenio.DataSource := DataSource;
    lbvariacao.SetParentComponent(Self);
    lbvariacao.Name := 'lbvariacao';
    lbvariacao.Left := 24;
    lbvariacao.Top := 462;
    lbvariacao.Width := 14;
    lbvariacao.Height := 13;
    lbvariacao.Caption := 'variacao:';
    lbvariacao.Transparent := True;
    edvariacao.SetParentComponent(Self);
    edvariacao.Name := 'edvariacao';
    edvariacao.Left := 221;
    edvariacao.Top := 459;
    edvariacao.Width := 200;
    edvariacao.Height := 21;
    edvariacao.Enabled := True;
    edvariacao.TabOrder := 16;
    edvariacao.Text := 'edvariacao';
    edvariacao.DataField := 'variacao';
    edvariacao.DataSource := DataSource;
    lbmensagem1.SetParentComponent(Self);
    lbmensagem1.Name := 'lbmensagem1';
    lbmensagem1.Left := 24;
    lbmensagem1.Top := 489;
    lbmensagem1.Width := 14;
    lbmensagem1.Height := 13;
    lbmensagem1.Caption := 'mensagem1:';
    lbmensagem1.Transparent := True;
    edmensagem1.SetParentComponent(Self);
    edmensagem1.Name := 'edmensagem1';
    edmensagem1.Left := 221;
    edmensagem1.Top := 486;
    edmensagem1.Width := 200;
    edmensagem1.Height := 21;
    edmensagem1.Enabled := True;
    edmensagem1.TabOrder := 17;
    edmensagem1.Text := 'edmensagem1';
    edmensagem1.DataField := 'mensagem1';
    edmensagem1.DataSource := DataSource;
    lbmensagem2.SetParentComponent(Self);
    lbmensagem2.Name := 'lbmensagem2';
    lbmensagem2.Left := 24;
    lbmensagem2.Top := 516;
    lbmensagem2.Width := 14;
    lbmensagem2.Height := 13;
    lbmensagem2.Caption := 'mensagem2:';
    lbmensagem2.Transparent := True;
    edmensagem2.SetParentComponent(Self);
    edmensagem2.Name := 'edmensagem2';
    edmensagem2.Left := 221;
    edmensagem2.Top := 513;
    edmensagem2.Width := 200;
    edmensagem2.Height := 21;
    edmensagem2.Enabled := True;
    edmensagem2.TabOrder := 18;
    edmensagem2.Text := 'edmensagem2';
    edmensagem2.DataField := 'mensagem2';
    edmensagem2.DataSource := DataSource;
    lbmensagem3.SetParentComponent(Self);
    lbmensagem3.Name := 'lbmensagem3';
    lbmensagem3.Left := 24;
    lbmensagem3.Top := 543;
    lbmensagem3.Width := 14;
    lbmensagem3.Height := 13;
    lbmensagem3.Caption := 'mensagem3:';
    lbmensagem3.Transparent := True;
    edmensagem3.SetParentComponent(Self);
    edmensagem3.Name := 'edmensagem3';
    edmensagem3.Left := 221;
    edmensagem3.Top := 540;
    edmensagem3.Width := 200;
    edmensagem3.Height := 21;
    edmensagem3.Enabled := True;
    edmensagem3.TabOrder := 19;
    edmensagem3.Text := 'edmensagem3';
    edmensagem3.DataField := 'mensagem3';
    edmensagem3.DataSource := DataSource;
    lbtaxa_juros.SetParentComponent(Self);
    lbtaxa_juros.Name := 'lbtaxa_juros';
    lbtaxa_juros.Left := 24;
    lbtaxa_juros.Top := 570;
    lbtaxa_juros.Width := 14;
    lbtaxa_juros.Height := 13;
    lbtaxa_juros.Caption := 'taxa_juros:';
    lbtaxa_juros.Transparent := True;
    edtaxa_juros.SetParentComponent(Self);
    edtaxa_juros.Name := 'edtaxa_juros';
    edtaxa_juros.Left := 221;
    edtaxa_juros.Top := 567;
    edtaxa_juros.Width := 200;
    edtaxa_juros.Height := 21;
    edtaxa_juros.Enabled := True;
    edtaxa_juros.TabOrder := 20;
    edtaxa_juros.Text := 'edtaxa_juros';
    edtaxa_juros.DataField := 'taxa_juros';
    edtaxa_juros.DataSource := DataSource;
    lbtaxa_multa.SetParentComponent(Self);
    lbtaxa_multa.Name := 'lbtaxa_multa';
    lbtaxa_multa.Left := 24;
    lbtaxa_multa.Top := 597;
    lbtaxa_multa.Width := 14;
    lbtaxa_multa.Height := 13;
    lbtaxa_multa.Caption := 'taxa_multa:';
    lbtaxa_multa.Transparent := True;
    edtaxa_multa.SetParentComponent(Self);
    edtaxa_multa.Name := 'edtaxa_multa';
    edtaxa_multa.Left := 221;
    edtaxa_multa.Top := 594;
    edtaxa_multa.Width := 200;
    edtaxa_multa.Height := 21;
    edtaxa_multa.Enabled := True;
    edtaxa_multa.TabOrder := 21;
    edtaxa_multa.Text := 'edtaxa_multa';
    edtaxa_multa.DataField := 'taxa_multa';
    edtaxa_multa.DataSource := DataSource;
    lbcarteira_cliente_emite_boleto.SetParentComponent(Self);
    lbcarteira_cliente_emite_boleto.Name := 'lbcarteira_cliente_emite_boleto';
    lbcarteira_cliente_emite_boleto.Left := 24;
    lbcarteira_cliente_emite_boleto.Top := 624;
    lbcarteira_cliente_emite_boleto.Width := 14;
    lbcarteira_cliente_emite_boleto.Height := 13;
    lbcarteira_cliente_emite_boleto.Caption := 'carteira_cliente_emite_boleto:';
    lbcarteira_cliente_emite_boleto.Transparent := True;
    edcarteira_cliente_emite_boleto.SetParentComponent(Self);
    edcarteira_cliente_emite_boleto.Name := 'edcarteira_cliente_emite_boleto';
    edcarteira_cliente_emite_boleto.Left := 221;
    edcarteira_cliente_emite_boleto.Top := 621;
    edcarteira_cliente_emite_boleto.Width := 200;
    edcarteira_cliente_emite_boleto.Height := 21;
    edcarteira_cliente_emite_boleto.Enabled := True;
    edcarteira_cliente_emite_boleto.TabOrder := 22;
    edcarteira_cliente_emite_boleto.Text := 'edcarteira_cliente_emite_boleto';
    edcarteira_cliente_emite_boleto.DataField := 'carteira_cliente_emite_boleto';
    edcarteira_cliente_emite_boleto.DataSource := DataSource;
    lbcarteira_permite_liquidacao_antecipada.SetParentComponent(Self);
    lbcarteira_permite_liquidacao_antecipada.Name := 'lbcarteira_permite_liquidacao_antecipada';
    lbcarteira_permite_liquidacao_antecipada.Left := 24;
    lbcarteira_permite_liquidacao_antecipada.Top := 651;
    lbcarteira_permite_liquidacao_antecipada.Width := 14;
    lbcarteira_permite_liquidacao_antecipada.Height := 13;
    lbcarteira_permite_liquidacao_antecipada.Caption := 'carteira_permite_liquidacao_antecipada:';
    lbcarteira_permite_liquidacao_antecipada.Transparent := True;
    edcarteira_permite_liquidacao_antecipada.SetParentComponent(Self);
    edcarteira_permite_liquidacao_antecipada.Name := 'edcarteira_permite_liquidacao_antecipada';
    edcarteira_permite_liquidacao_antecipada.Left := 221;
    edcarteira_permite_liquidacao_antecipada.Top := 648;
    edcarteira_permite_liquidacao_antecipada.Width := 200;
    edcarteira_permite_liquidacao_antecipada.Height := 21;
    edcarteira_permite_liquidacao_antecipada.Enabled := True;
    edcarteira_permite_liquidacao_antecipada.TabOrder := 23;
    edcarteira_permite_liquidacao_antecipada.Text := 'edcarteira_permite_liquidacao_antecipada';
    edcarteira_permite_liquidacao_antecipada.DataField := 'carteira_permite_liquidacao_antecipada';
    edcarteira_permite_liquidacao_antecipada.DataSource := DataSource;
    lbdesconto_acrescimo_antecipacao.SetParentComponent(Self);
    lbdesconto_acrescimo_antecipacao.Name := 'lbdesconto_acrescimo_antecipacao';
    lbdesconto_acrescimo_antecipacao.Left := 24;
    lbdesconto_acrescimo_antecipacao.Top := 678;
    lbdesconto_acrescimo_antecipacao.Width := 14;
    lbdesconto_acrescimo_antecipacao.Height := 13;
    lbdesconto_acrescimo_antecipacao.Caption := 'desconto_acrescimo_antecipacao:';
    lbdesconto_acrescimo_antecipacao.Transparent := True;
    eddesconto_acrescimo_antecipacao.SetParentComponent(Self);
    eddesconto_acrescimo_antecipacao.Name := 'eddesconto_acrescimo_antecipacao';
    eddesconto_acrescimo_antecipacao.Left := 221;
    eddesconto_acrescimo_antecipacao.Top := 675;
    eddesconto_acrescimo_antecipacao.Width := 200;
    eddesconto_acrescimo_antecipacao.Height := 21;
    eddesconto_acrescimo_antecipacao.Enabled := True;
    eddesconto_acrescimo_antecipacao.TabOrder := 24;
    eddesconto_acrescimo_antecipacao.Text := 'eddesconto_acrescimo_antecipacao';
    eddesconto_acrescimo_antecipacao.DataField := 'desconto_acrescimo_antecipacao';
    eddesconto_acrescimo_antecipacao.DataSource := DataSource;
    lbtaxa_desconto_acrescimo_antecipado.SetParentComponent(Self);
    lbtaxa_desconto_acrescimo_antecipado.Name := 'lbtaxa_desconto_acrescimo_antecipado';
    lbtaxa_desconto_acrescimo_antecipado.Left := 24;
    lbtaxa_desconto_acrescimo_antecipado.Top := 705;
    lbtaxa_desconto_acrescimo_antecipado.Width := 14;
    lbtaxa_desconto_acrescimo_antecipado.Height := 13;
    lbtaxa_desconto_acrescimo_antecipado.Caption := 'taxa_desconto_acrescimo_antecipado:';
    lbtaxa_desconto_acrescimo_antecipado.Transparent := True;
    edtaxa_desconto_acrescimo_antecipado.SetParentComponent(Self);
    edtaxa_desconto_acrescimo_antecipado.Name := 'edtaxa_desconto_acrescimo_antecipado';
    edtaxa_desconto_acrescimo_antecipado.Left := 221;
    edtaxa_desconto_acrescimo_antecipado.Top := 702;
    edtaxa_desconto_acrescimo_antecipado.Width := 200;
    edtaxa_desconto_acrescimo_antecipado.Height := 21;
    edtaxa_desconto_acrescimo_antecipado.Enabled := True;
    edtaxa_desconto_acrescimo_antecipado.TabOrder := 25;
    edtaxa_desconto_acrescimo_antecipado.Text := 'edtaxa_desconto_acrescimo_antecipado';
    edtaxa_desconto_acrescimo_antecipado.DataField := 'taxa_desconto_acrescimo_antecipado';
    edtaxa_desconto_acrescimo_antecipado.DataSource := DataSource;
    lbdias_limite_desconto_acrescimo_antecipacao.SetParentComponent(Self);
    lbdias_limite_desconto_acrescimo_antecipacao.Name := 'lbdias_limite_desconto_acrescimo_antecipacao';
    lbdias_limite_desconto_acrescimo_antecipacao.Left := 24;
    lbdias_limite_desconto_acrescimo_antecipacao.Top := 732;
    lbdias_limite_desconto_acrescimo_antecipacao.Width := 14;
    lbdias_limite_desconto_acrescimo_antecipacao.Height := 13;
    lbdias_limite_desconto_acrescimo_antecipacao.Caption := 'dias_limite_desconto_acrescimo_antecipacao:';
    lbdias_limite_desconto_acrescimo_antecipacao.Transparent := True;
    eddias_limite_desconto_acrescimo_antecipacao.SetParentComponent(Self);
    eddias_limite_desconto_acrescimo_antecipacao.Name := 'eddias_limite_desconto_acrescimo_antecipacao';
    eddias_limite_desconto_acrescimo_antecipacao.Left := 221;
    eddias_limite_desconto_acrescimo_antecipacao.Top := 729;
    eddias_limite_desconto_acrescimo_antecipacao.Width := 200;
    eddias_limite_desconto_acrescimo_antecipacao.Height := 21;
    eddias_limite_desconto_acrescimo_antecipacao.Enabled := True;
    eddias_limite_desconto_acrescimo_antecipacao.TabOrder := 26;
    eddias_limite_desconto_acrescimo_antecipacao.Text := 'eddias_limite_desconto_acrescimo_antecipacao';
    eddias_limite_desconto_acrescimo_antecipacao.DataField := 'dias_limite_desconto_acrescimo_antecipacao';
    eddias_limite_desconto_acrescimo_antecipacao.DataSource := DataSource;
    lbmensagem_desconto.SetParentComponent(Self);
    lbmensagem_desconto.Name := 'lbmensagem_desconto';
    lbmensagem_desconto.Left := 24;
    lbmensagem_desconto.Top := 759;
    lbmensagem_desconto.Width := 14;
    lbmensagem_desconto.Height := 13;
    lbmensagem_desconto.Caption := 'mensagem_desconto:';
    lbmensagem_desconto.Transparent := True;
    edmensagem_desconto.SetParentComponent(Self);
    edmensagem_desconto.Name := 'edmensagem_desconto';
    edmensagem_desconto.Left := 221;
    edmensagem_desconto.Top := 756;
    edmensagem_desconto.Width := 200;
    edmensagem_desconto.Height := 21;
    edmensagem_desconto.Enabled := True;
    edmensagem_desconto.TabOrder := 27;
    edmensagem_desconto.Text := 'edmensagem_desconto';
    edmensagem_desconto.DataField := 'mensagem_desconto';
    edmensagem_desconto.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 786;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 783;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 28;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 813;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 810;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 29;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 840;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 837;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 30;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 867;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 864;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 31;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 894;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 891;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 32;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Banco_CarteirasDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Banco_CarteirasDataset.SetParentComponent(Self);
    Banco_CarteirasDataset.Name := 'Banco_CarteirasDataset';
    Banco_CarteirasDataset.AfterApplyUpdates := Banco_CarteirasDatasetAfterApplyUpdates;
    Banco_CarteirasDataset.EntitySetName := 'Banco_Carteiras';
    Banco_CarteirasDataset.Connection := DMConnection.ApiConnection;
    Banco_CarteirasDataset.Left := 176;
    Banco_CarteirasDataset.Top := 8;
    Banco_CarteirasDatasetid.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetid.Name := 'Banco_CarteirasDatasetid';
    Banco_CarteirasDatasetid.FieldName := 'id';
    Banco_CarteirasDatasetid.Required := True;
    Banco_CarteirasDatasetaliado_id.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetaliado_id.Name := 'Banco_CarteirasDatasetaliado_id';
    Banco_CarteirasDatasetaliado_id.FieldName := 'aliado_id';
    Banco_CarteirasDatasetaliado_id.Required := True;
    Banco_CarteirasDatasetdata_base_id.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetdata_base_id.Name := 'Banco_CarteirasDatasetdata_base_id';
    Banco_CarteirasDatasetdata_base_id.FieldName := 'data_base_id';
    Banco_CarteirasDatasetdata_base_id.Required := True;
    Banco_CarteirasDatasetconta_id.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetconta_id.Name := 'Banco_CarteirasDatasetconta_id';
    Banco_CarteirasDatasetconta_id.FieldName := 'conta_id';
    Banco_CarteirasDatasetconta_id.Required := False;
    Banco_CarteirasDatasettipo_id.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasettipo_id.Name := 'Banco_CarteirasDatasettipo_id';
    Banco_CarteirasDatasettipo_id.FieldName := 'tipo_id';
    Banco_CarteirasDatasettipo_id.Required := False;
    Banco_CarteirasDatasetstatus.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetstatus.Name := 'Banco_CarteirasDatasetstatus';
    Banco_CarteirasDatasetstatus.FieldName := 'status';
    Banco_CarteirasDatasetstatus.Required := False;
    Banco_CarteirasDatasetnome.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetnome.Name := 'Banco_CarteirasDatasetnome';
    Banco_CarteirasDatasetnome.FieldName := 'nome';
    Banco_CarteirasDatasetnome.Required := True;
    Banco_CarteirasDatasetnome.Size := 255;
    Banco_CarteirasDatasetcodigo.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetcodigo.Name := 'Banco_CarteirasDatasetcodigo';
    Banco_CarteirasDatasetcodigo.FieldName := 'codigo';
    Banco_CarteirasDatasetcodigo.Required := False;
    Banco_CarteirasDatasetcodigo.Size := 255;
    Banco_CarteirasDatasetcontrato.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetcontrato.Name := 'Banco_CarteirasDatasetcontrato';
    Banco_CarteirasDatasetcontrato.FieldName := 'contrato';
    Banco_CarteirasDatasetcontrato.Required := False;
    Banco_CarteirasDatasetcontrato.Size := 255;
    Banco_CarteirasDatasetconvenio.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetconvenio.Name := 'Banco_CarteirasDatasetconvenio';
    Banco_CarteirasDatasetconvenio.FieldName := 'convenio';
    Banco_CarteirasDatasetconvenio.Required := False;
    Banco_CarteirasDatasetconvenio.Size := 255;
    Banco_CarteirasDatasetvariacao.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetvariacao.Name := 'Banco_CarteirasDatasetvariacao';
    Banco_CarteirasDatasetvariacao.FieldName := 'variacao';
    Banco_CarteirasDatasetvariacao.Required := False;
    Banco_CarteirasDatasetvariacao.Size := 255;
    Banco_CarteirasDatasetmensagem1.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetmensagem1.Name := 'Banco_CarteirasDatasetmensagem1';
    Banco_CarteirasDatasetmensagem1.FieldName := 'mensagem1';
    Banco_CarteirasDatasetmensagem1.Required := False;
    Banco_CarteirasDatasetmensagem1.Size := 255;
    Banco_CarteirasDatasetmensagem2.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetmensagem2.Name := 'Banco_CarteirasDatasetmensagem2';
    Banco_CarteirasDatasetmensagem2.FieldName := 'mensagem2';
    Banco_CarteirasDatasetmensagem2.Required := False;
    Banco_CarteirasDatasetmensagem2.Size := 255;
    Banco_CarteirasDatasetmensagem3.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetmensagem3.Name := 'Banco_CarteirasDatasetmensagem3';
    Banco_CarteirasDatasetmensagem3.FieldName := 'mensagem3';
    Banco_CarteirasDatasetmensagem3.Required := False;
    Banco_CarteirasDatasetmensagem3.Size := 255;
    Banco_CarteirasDatasettaxa_juros.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasettaxa_juros.Name := 'Banco_CarteirasDatasettaxa_juros';
    Banco_CarteirasDatasettaxa_juros.FieldName := 'taxa_juros';
    Banco_CarteirasDatasettaxa_juros.Required := False;
    Banco_CarteirasDatasettaxa_multa.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasettaxa_multa.Name := 'Banco_CarteirasDatasettaxa_multa';
    Banco_CarteirasDatasettaxa_multa.FieldName := 'taxa_multa';
    Banco_CarteirasDatasettaxa_multa.Required := False;
    Banco_CarteirasDatasetcarteira_cliente_emite_boleto.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetcarteira_cliente_emite_boleto.Name := 'Banco_CarteirasDatasetcarteira_cliente_emite_boleto';
    Banco_CarteirasDatasetcarteira_cliente_emite_boleto.FieldName := 'carteira_cliente_emite_boleto';
    Banco_CarteirasDatasetcarteira_cliente_emite_boleto.Required := True;
    Banco_CarteirasDatasetcarteira_permite_liquidacao_antecipada.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetcarteira_permite_liquidacao_antecipada.Name := 'Banco_CarteirasDatasetcarteira_permite_liquidacao_antecipada';
    Banco_CarteirasDatasetcarteira_permite_liquidacao_antecipada.FieldName := 'carteira_permite_liquidacao_antecipada';
    Banco_CarteirasDatasetcarteira_permite_liquidacao_antecipada.Required := True;
    Banco_CarteirasDatasetdesconto_acrescimo_antecipacao.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetdesconto_acrescimo_antecipacao.Name := 'Banco_CarteirasDatasetdesconto_acrescimo_antecipacao';
    Banco_CarteirasDatasetdesconto_acrescimo_antecipacao.FieldName := 'desconto_acrescimo_antecipacao';
    Banco_CarteirasDatasetdesconto_acrescimo_antecipacao.Required := False;
    Banco_CarteirasDatasettaxa_desconto_acrescimo_antecipado.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasettaxa_desconto_acrescimo_antecipado.Name := 'Banco_CarteirasDatasettaxa_desconto_acrescimo_antecipado';
    Banco_CarteirasDatasettaxa_desconto_acrescimo_antecipado.FieldName := 'taxa_desconto_acrescimo_antecipado';
    Banco_CarteirasDatasettaxa_desconto_acrescimo_antecipado.Required := False;
    Banco_CarteirasDatasetdias_limite_desconto_acrescimo_antecipacao.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetdias_limite_desconto_acrescimo_antecipacao.Name := 'Banco_CarteirasDatasetdias_limite_desconto_acrescimo_antecipacao';
    Banco_CarteirasDatasetdias_limite_desconto_acrescimo_antecipacao.FieldName := 'dias_limite_desconto_acrescimo_antecipacao';
    Banco_CarteirasDatasetdias_limite_desconto_acrescimo_antecipacao.Required := False;
    Banco_CarteirasDatasetmensagem_desconto.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetmensagem_desconto.Name := 'Banco_CarteirasDatasetmensagem_desconto';
    Banco_CarteirasDatasetmensagem_desconto.FieldName := 'mensagem_desconto';
    Banco_CarteirasDatasetmensagem_desconto.Required := False;
    Banco_CarteirasDatasetmensagem_desconto.Size := 255;
    Banco_CarteirasDatasetcodigo_interno.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetcodigo_interno.Name := 'Banco_CarteirasDatasetcodigo_interno';
    Banco_CarteirasDatasetcodigo_interno.FieldName := 'codigo_interno';
    Banco_CarteirasDatasetcodigo_interno.Required := True;
    Banco_CarteirasDatasetexcluido.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetexcluido.Name := 'Banco_CarteirasDatasetexcluido';
    Banco_CarteirasDatasetexcluido.FieldName := 'excluido';
    Banco_CarteirasDatasetexcluido.Required := False;
    Banco_CarteirasDatasetinclusao.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetinclusao.Name := 'Banco_CarteirasDatasetinclusao';
    Banco_CarteirasDatasetinclusao.FieldName := 'inclusao';
    Banco_CarteirasDatasetinclusao.Required := False;
    Banco_CarteirasDatasetalteracao.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetalteracao.Name := 'Banco_CarteirasDatasetalteracao';
    Banco_CarteirasDatasetalteracao.FieldName := 'alteracao';
    Banco_CarteirasDatasetalteracao.Required := False;
    Banco_CarteirasDatasetexclusao.SetParentComponent(Banco_CarteirasDataset);
    Banco_CarteirasDatasetexclusao.Name := 'Banco_CarteirasDatasetexclusao';
    Banco_CarteirasDatasetexclusao.FieldName := 'exclusao';
    Banco_CarteirasDatasetexclusao.Required := False;
    XDataClientBanco_CarteirasGet.SetParentComponent(Self);
    XDataClientBanco_CarteirasGet.Name := 'XDataClientBanco_CarteirasGet';
    XDataClientBanco_CarteirasGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientBanco_CarteirasGet, Self, 'OnLoad', 'XDataClientBanco_CarteirasGetLoad');
    XDataClientBanco_CarteirasGet.Left := 64;
    XDataClientBanco_CarteirasGet.Top := 8;
    XDataClientBanco_CarteirasDelete.SetParentComponent(Self);
    XDataClientBanco_CarteirasDelete.Name := 'XDataClientBanco_CarteirasDelete';
    XDataClientBanco_CarteirasDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientBanco_CarteirasDelete, Self, 'OnLoad', 'XDataClientBanco_CarteirasDeleteLoad');
    SetEvent(XDataClientBanco_CarteirasDelete, Self, 'OnError', 'XDataClientBanco_CarteirasDeleteError');
    XDataClientBanco_CarteirasDelete.Left := 64;
    XDataClientBanco_CarteirasDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbconta_id.AfterLoadDFMValues;
    edconta_id.AfterLoadDFMValues;
    lbtipo_id.AfterLoadDFMValues;
    edtipo_id.AfterLoadDFMValues;
    lbstatus.AfterLoadDFMValues;
    edstatus.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbcodigo.AfterLoadDFMValues;
    edcodigo.AfterLoadDFMValues;
    lbcontrato.AfterLoadDFMValues;
    edcontrato.AfterLoadDFMValues;
    lbconvenio.AfterLoadDFMValues;
    edconvenio.AfterLoadDFMValues;
    lbvariacao.AfterLoadDFMValues;
    edvariacao.AfterLoadDFMValues;
    lbmensagem1.AfterLoadDFMValues;
    edmensagem1.AfterLoadDFMValues;
    lbmensagem2.AfterLoadDFMValues;
    edmensagem2.AfterLoadDFMValues;
    lbmensagem3.AfterLoadDFMValues;
    edmensagem3.AfterLoadDFMValues;
    lbtaxa_juros.AfterLoadDFMValues;
    edtaxa_juros.AfterLoadDFMValues;
    lbtaxa_multa.AfterLoadDFMValues;
    edtaxa_multa.AfterLoadDFMValues;
    lbcarteira_cliente_emite_boleto.AfterLoadDFMValues;
    edcarteira_cliente_emite_boleto.AfterLoadDFMValues;
    lbcarteira_permite_liquidacao_antecipada.AfterLoadDFMValues;
    edcarteira_permite_liquidacao_antecipada.AfterLoadDFMValues;
    lbdesconto_acrescimo_antecipacao.AfterLoadDFMValues;
    eddesconto_acrescimo_antecipacao.AfterLoadDFMValues;
    lbtaxa_desconto_acrescimo_antecipado.AfterLoadDFMValues;
    edtaxa_desconto_acrescimo_antecipado.AfterLoadDFMValues;
    lbdias_limite_desconto_acrescimo_antecipacao.AfterLoadDFMValues;
    eddias_limite_desconto_acrescimo_antecipacao.AfterLoadDFMValues;
    lbmensagem_desconto.AfterLoadDFMValues;
    edmensagem_desconto.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Banco_CarteirasDataset.AfterLoadDFMValues;
    Banco_CarteirasDatasetid.AfterLoadDFMValues;
    Banco_CarteirasDatasetaliado_id.AfterLoadDFMValues;
    Banco_CarteirasDatasetdata_base_id.AfterLoadDFMValues;
    Banco_CarteirasDatasetconta_id.AfterLoadDFMValues;
    Banco_CarteirasDatasettipo_id.AfterLoadDFMValues;
    Banco_CarteirasDatasetstatus.AfterLoadDFMValues;
    Banco_CarteirasDatasetnome.AfterLoadDFMValues;
    Banco_CarteirasDatasetcodigo.AfterLoadDFMValues;
    Banco_CarteirasDatasetcontrato.AfterLoadDFMValues;
    Banco_CarteirasDatasetconvenio.AfterLoadDFMValues;
    Banco_CarteirasDatasetvariacao.AfterLoadDFMValues;
    Banco_CarteirasDatasetmensagem1.AfterLoadDFMValues;
    Banco_CarteirasDatasetmensagem2.AfterLoadDFMValues;
    Banco_CarteirasDatasetmensagem3.AfterLoadDFMValues;
    Banco_CarteirasDatasettaxa_juros.AfterLoadDFMValues;
    Banco_CarteirasDatasettaxa_multa.AfterLoadDFMValues;
    Banco_CarteirasDatasetcarteira_cliente_emite_boleto.AfterLoadDFMValues;
    Banco_CarteirasDatasetcarteira_permite_liquidacao_antecipada.AfterLoadDFMValues;
    Banco_CarteirasDatasetdesconto_acrescimo_antecipacao.AfterLoadDFMValues;
    Banco_CarteirasDatasettaxa_desconto_acrescimo_antecipado.AfterLoadDFMValues;
    Banco_CarteirasDatasetdias_limite_desconto_acrescimo_antecipacao.AfterLoadDFMValues;
    Banco_CarteirasDatasetmensagem_desconto.AfterLoadDFMValues;
    Banco_CarteirasDatasetcodigo_interno.AfterLoadDFMValues;
    Banco_CarteirasDatasetexcluido.AfterLoadDFMValues;
    Banco_CarteirasDatasetinclusao.AfterLoadDFMValues;
    Banco_CarteirasDatasetalteracao.AfterLoadDFMValues;
    Banco_CarteirasDatasetexclusao.AfterLoadDFMValues;
    XDataClientBanco_CarteirasGet.AfterLoadDFMValues;
    XDataClientBanco_CarteirasDelete.AfterLoadDFMValues;
  end;
end;

end.
